import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';

import { requestUserTokenPersist } from '@atom/actions/userActions';
import { Progress } from '@atom/mui';
import { CURRENT_SUBDOMAIN } from '@atom/utilities/endpoints';

const AuthCallback = () => {
  const dispatch = useDispatch();

  const getToken = (): string => {
    return window.location.pathname.split('/callback/').join('').split('#')[0];
  };

  const getTenant = (): string => {
    const params = new URLSearchParams(window.location.search);
    return params.get('tenant');
  };

  useEffect(() => {
    const token = getToken();
    const tenant = getTenant();

    if (CURRENT_SUBDOMAIN === tenant) {
      dispatch(requestUserTokenPersist({ token }));
    } else {
      const subDomain = tenant ? tenant : 'www';
      const hostLocation = window.location.host;
      const protocol = window.location.protocol;
      const domain = R.pipe(
        R.split('.'),
        R.drop(1),
        R.prepend(`${protocol}//${subDomain}`),
        R.join('.'),
      )(hostLocation);

      window.location.href = `${domain}/callback/${token}?tenant=${subDomain}`;
    }
  }, []);

  return <Progress />;
};

export default AuthCallback;
